module.exports = __webpack_public_path__ + "img/border.5e3bfdae.png";